var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_3687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69162 2.25647C8.93959 2.25647 11.1248 2.25647 13.3832 2.25647C13.3832 1.89053 13.3728 1.52458 13.3832 1.16909C13.4042 0.489468 13.8433 0.0398742 14.4811 0.0294185C15.1293 0.0189629 15.558 0.458101 15.5894 1.14817C15.6417 2.25647 15.6417 2.25647 16.75 2.27739C18.6947 2.32966 20.0749 3.72027 20.0749 5.64411C20.0749 10.0669 20.0749 14.4896 20.0749 18.9228C20.0749 20.9094 18.7156 22.3418 16.7186 22.3523C12.2749 22.3836 7.83129 22.3732 3.38763 22.3523C1.36969 22.3418 0 20.9094 0 18.8914C0 14.5001 0 10.1087 0 5.7173C0 3.6889 1.35924 2.30875 3.38763 2.27739C4.44366 2.26693 4.44366 2.26693 4.46457 1.22136C4.49593 0.479012 4.89325 0.0398742 5.56241 0.0294185C6.24203 0.0189629 6.68117 0.489468 6.69162 1.25273C6.69162 1.57686 6.69162 1.90098 6.69162 2.25647ZM17.8583 11.217C12.6095 11.217 7.44443 11.217 2.24797 11.217C2.23751 11.3843 2.22706 11.5097 2.22706 11.6457C2.22706 14.0191 2.22706 16.3821 2.22706 18.7555C2.22706 19.7488 2.593 20.0938 3.58629 20.0938C7.88357 20.0938 12.1913 20.0938 16.4886 20.0938C17.5132 20.0938 17.8583 19.7488 17.8583 18.7032C17.8583 16.5807 17.8583 14.4582 17.8583 12.3253C17.8583 11.9802 17.8583 11.6143 17.8583 11.217ZM6.69162 4.52535C6.69162 4.95404 6.70208 5.31998 6.69162 5.68593C6.66026 6.34464 6.23157 6.72104 5.56241 6.72104C4.91416 6.71059 4.51685 6.34464 4.48548 5.69639C4.46457 5.31998 4.48548 4.93312 4.48548 4.50444C4.14044 4.50444 3.84768 4.50444 3.55492 4.50444C2.61391 4.50444 2.23751 4.8913 2.22706 5.84277C2.2166 6.71059 2.24797 7.58886 2.2166 8.45668C2.20614 8.86445 2.32116 8.98992 2.73938 8.98992C5.07099 8.96901 7.41306 8.97947 9.74467 8.97947C12.2854 8.97947 14.8366 8.97947 17.3773 8.97947C17.6178 8.97947 17.8792 9.03174 17.8687 8.63443C17.8583 7.62023 17.8792 6.61649 17.8583 5.60229C17.8478 5.02723 17.5237 4.609 17.0323 4.54626C16.5827 4.48353 16.1122 4.53581 15.6103 4.53581C15.6103 4.93312 15.6208 5.27816 15.6103 5.63365C15.5894 6.34464 15.1921 6.7315 14.502 6.7315C13.8224 6.7315 13.4146 6.32373 13.4042 5.61274C13.3937 5.25725 13.4042 4.90176 13.4042 4.53581C11.1248 4.52535 8.92913 4.52535 6.69162 4.52535Z",
    fill: "url(#paint0_linear_342_3687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90844 15.6503C8.90844 16.0476 8.9189 16.4554 8.90844 16.8527C8.87707 17.4905 8.49021 17.8669 7.84196 17.8774C7.0787 17.8878 6.31544 17.8983 5.55217 17.8774C4.90392 17.8669 4.51706 17.4801 4.49615 16.8318C4.47524 16.0476 4.47524 15.2635 4.49615 14.4897C4.50661 13.8624 4.85164 13.4755 5.48944 13.4337C6.28407 13.3919 7.08916 13.3919 7.88379 13.4337C8.5634 13.4651 8.89799 13.8728 8.9189 14.5629C8.9189 14.9184 8.90844 15.2844 8.90844 15.6503Z",
    fill: "url(#paint1_linear_342_3687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_3687",
    x1: 0,
    y1: 12.5971,
    x2: 20.0749,
    y2: 12.5971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_342_3687",
    x1: 4.48047,
    y1: 15.9263,
    x2: 8.9189,
    y2: 15.9263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_3687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0749,
    height: 22.3437,
    fill: "white",
    transform: "translate(0 0.029541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.2f7c15f84f6d9f2a33862ddb4c6b3df1.svg";
export { ForwardRef as ReactComponent };